<template>
	<div class="max-w-6xl py-12 mx-auto space-y-4">
		<p v-if="error" class="error">
			{{ error }}
		</p>
		<FAQ />
	</div>
</template>

<script>
import FAQ from '../components/FAQs.vue';

export default {
	name: 'FAQMain',
	components: {
		FAQ,
	},	
	data() {
		return {
			error: undefined,
		};
	},
	methods: {
		onError(e) {
			this.error = e.text;
		},
	},
};
</script>
